import { Component } from 'vue';

import ItpModal from './ItpModal.vue';
import ItpConfirmDialog from './ItpConfirmDialog.vue';
import ItpMessageBox from './ItpMessageBox.vue';

const registry: Record<string, Component> = {
  ItpModal,
  ConfirmDialog: ItpConfirmDialog,
  MessageBox: ItpMessageBox,
};

export function getModalComponent(name: string): Component | undefined {
  return registry[name];
}

export function registerModal(name: string, comp: Component) {
  registry[name] = comp;
}
